import {
  IDeleteUserDevice,
  IEditUser,
  IParamsGetUser,
  IResetPassword,
  IResponseGetUser,
  IResponseGetUserDetail,
  ISessionByUser,
} from '~/utils/interface/user';
import axiosClient from './axiosClient';

const url: string = '/api/account';

const userApi = {
  getList(data: IParamsGetUser) {
    return axiosClient.post<IResponseGetUser>(url + '/find-by-role?role=user', data);
  },
  getSessionByUser(username: string) {
    return axiosClient.get<Array<ISessionByUser>>(url + '/get-sessions-by-user/' + username);
  },
  search(params: any) {
    return axiosClient.get<any>(url + '/search', { params });
  },
  resetPassword(data: IResetPassword) {
    return axiosClient.post<any>('/api/auth/admin/reset-password', data);
  },
  create(data: IEditUser) {
    return axiosClient.post<IResponseGetUserDetail>(`${url}/create-by-role?role=user`, data);
  },
  update(data: IEditUser) {
    return axiosClient.put<IResponseGetUserDetail>(url + '/update', data);
  },
  delete(username: string) {
    return axiosClient.delete<any>(`${url}/self-delete-user?username=${username}`);
  },
  deleteDevice(username: string, data: IDeleteUserDevice) {
    return axiosClient.delete<any>(`/api/device/delete-by-user?username=${username}`, { data });
  },
};
export default userApi;
